import { render, staticRenderFns } from "./commonDetail.vue?vue&type=template&id=3266264b&scoped=true&"
import script from "./commonDetail.vue?vue&type=script&lang=js&"
export * from "./commonDetail.vue?vue&type=script&lang=js&"
import style0 from "./commonDetail.vue?vue&type=style&index=0&id=3266264b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3266264b",
  null
  
)

export default component.exports